import {
    Notification,
} from 'element-ui'

const localState = {
    data: null,
    clientRequests: [],
    search: '',
    newClients: 0,
    client: null,
    clientReviews: null,
    modal: false,
    deletion_tag: false,
    type: 'add',
    schedule: {
        service_id: null,
        days: [1, 2, 3, 4, 5],
        time_base_price: {
            from: null,
            to: null,
        },
        time_extra_price_1: {
            from: null,
            to: null,
        },
        time_extra_price_2: {
            from: null,
            to: null,
        },
        date: null,
    },
    scheduleList: null,
    scheduleListByService: null,
    scheduleParams: null,
    scheduleParamsService: null,
    isOpenedClientScheduleModal: false,
    scheduleServiceId: 'all',
    scheduleOfficeId: null,
    params: {
        office_id: null,
    },
    historyCommunication: null,
}

const mutations = {
    setState(state, {
        type,
        data,
    }) {
        state[type] = data
    },
    setScheduleServiceId: (state, v) => {
        state.scheduleServiceId = v
    },
    setClientScheduleParams: (state, v) => {
        state.scheduleParams = v
    },
    setClientScheduleParamsByService: (state, v) => {
        state.scheduleParamsService = v
    },
    clientsData(state, {
        data,
    }) {
        state.data = data
    },
    udpateObject(state, {
        data,
    }) {
        for (const key in state[data]) {
            state[data][key] = ''
        }
    },
    setRequests(state, data) {
        state.clientRequests = data
    },
    setClientModal: (state, v) => {
        state.modal = v
    },
    setClientPhone: (state, v) => {
        if (state.client) state.client.phone = v
    },
    setClientsDeletionStatus: (state, v) => {
        state.deletion_tag = v
    },
    setClient: (state, v) => {
        state.client = v
    },
    clearClientModal: (state) => {
        state.clientReviews = null
        state.client = null
    },
    setCLient: (state) => {
        state.client = {
            first_name: null,
            last_name: null,
            email: null,
            phone: null,
            company_name: null,
            payment_type: null,
            big_image: null,
            small_image: null,
            type: null,
            created_at: null,
            addresses: null,
            is_read: null,
            deletion_tag: false,
        }
    },
    setClientModalType: (state, v) => {
        state.type = v
    },
    closeClientScheduleModal: (state) => {
        state.isOpenedClientScheduleModal = false
    },
    openClientScheduleModal: (state) => {
        state.isOpenedClientScheduleModal = true
    },
    clearSchedule: (state) => {
        state.schedule = {
            service_id: null,
            days: [1, 2, 3, 4, 5],
            time_base_price: {
                from: null,
                to: null,
            },
            time_extra_price_1: {
                from: null,
                to: null,
            },
            time_extra_price_2: {
                from: null,
                to: null,
            },
            date: null,
        }
    },
    setScheduleDay: (state, v) => {
        state.schedule.date = v
    },
    setScheduleFormServiceId: (state, v) => {
        state.schedule.service_id = v
    },
    setScheduleOfficeId: (state, v) => {
        state.scheduleOfficeId = v
    },
    clearClientParams: (state) => {
        state.params = {
            office_id: null,
        }
    },
}

const actions = {
    async fetchNewClientsCount({
        commit,
    }) {
        try {
            const response = await this.$api.clients.statistics()
            commit('setState', {
                type: 'newClients',
                data: response.data.data.qty_new_clients,
            })
        } catch (err) {
            console.log(err)
        }
    },

    async readClient(_, {
        id,
        is_read,
    }) {
        try {
            await this.$api.clients.markClientAsRead({
                id,
                is_read,
            })
            await this.dispatch('fetchNewClientsCount')
        } catch (err) {
            console.log(err)
        }
    },

    async fetchById({
        commit,
        dispatch,
    }, id) {
        try {
            const response = await this.$api.clients.fetchById(id)
            commit('setState', {
                type: 'client',
                data: response.data,
            })

            await dispatch('fetchClientComments', id)
        } catch (err) {
            console.log(err)
        }
    },

    async fetchHistoryCommunication({
        commit,
    }, id) {
        const response = await this.$api.clients.fetchHistoryCommunication(id)

        commit('setState', {
            type: 'historyCommunication',
            data: response.data,
        })
    },

    async fetchClientRequests({
        commit,
    }, id) {
        try {
            const response = await this.$api.orders.fetchClientRequests(id)
            commit('setRequests', response.data.data || [])
        } catch (err) {
            console.log(err)
        }
    },

    async fetchClientComments({
        commit,
    }, id) {
        try {
            const response = await this.$api.clients.fetchCommentsById(id)
            commit('setState', {
                type: 'clientReviews',
                data: response.data.data,
            })
        } catch (err) {
            console.log(err)
        }
    },

    async getClientsData({
        commit,
    }, {
        word = null,
        params = null,
    }) {
        try {
            let query = ''
            if (word !== null) {
                query = `?search=${word}`
            }

            let paramsQuery = ''
            if ((params && params.office_id !== 'all') && (params && params.office_id !== null)) {
                if (query) paramsQuery = `&office_id=${params.office_id}`
                else paramsQuery = `?office_id=${params.office_id}`
            }

            const response = await this.$api.clients.fetch({
                query,
                params: paramsQuery,
            })
            commit('clientsData', {
                data: response.data.data !== undefined ? response.data.data : [],
            })
            return response.data.data
        } catch (err) {
            console.log(err)
        }
    },

    async updateClientAddresses(_, addresses) {
        try {
            if (addresses.length === 0) {
                return status
            }

            addresses.forEach((element) => {
                this.$api.clients.updateAddressesById(
                    element.id,
                    element,
                )
            })
        } catch (err) {
            console.log(err)
        }
    },

    async updateClient({
        state,
        dispatch,
    }) {
        try {
            const user = {
                first_name: state.client.first_name,
                last_name: state.client.last_name,
                phone: state.client.phone,
                email: state.client.email,
            }

            const response = await this.$api.clients.updateById(
                state.client.id,
                user,
            )

            if (response.status !== 200) return

            dispatch('updateClientAddresses', state.client.addresses)
            return true
        } catch (err) {
            console.log(err)
        }
    },

    async createClient(_, client) {
        try {
            return await this.$api.clients.create(client)
        } catch (err) {
            console.log(err)
        }
    },

    async updateClientImage(_, {
        fd,
        id,
    }) {
        try {
            const response = await this.$api.clients.updateImageById(id, fd)
            return response.status === 200
        } catch (err) {
            console.log(err)
        }
    },

    async deleteClient({
        state,
        dispatch,
    }, id) {
        try {
            const response = await this.$api.clients.remove(id)
            const isOkey = response.status === 200 || response.status === 201 || response.status === 204

            if (!isOkey) return

            dispatch('getClientsData', {
                params: state.params,
            })
            state.search = ''

            if (response.status === 409) {
                Notification({
                    title: 'Error',
                    message: response.data.fields[0].message,
                    duration: 5000,
                })
            }
        } catch (err) {
            console.log(err)
        }
    },

    async addClientSchedule(_, form) {
        try {
            const response = await this.$api.clients.addSchedule(form)
            return response.status === 204
        } catch (err) {
            console.log(err)
        }
    },
    async addClientScheduleByDay(_, form) {
        try {
            const response = await this.$api.clients.addScheduleByDay(form)
            return response.status === 204
        } catch (err) {
            console.log(err)
        }
    },

    async fetchClientSchedule({
        state,
        commit,
    }) {
        try {
            const response = await this.$api.clients.fetchSchedule(
                state.scheduleParams,
            )

            commit('setState', {
                type: 'scheduleList',
                data: response.data,
            })
        } catch (err) {
            // log err
        }
    },

    async fetchClientScheduleById({
        state,
        commit,
    }) {
        try {
            const response = await this.$api.clients.fetchScheduleById(
                state.scheduleParamsService,
            )

            commit('setState', {
                type: 'scheduleListByService',
                data: response.data,
            })
        } catch (err) {
            // log err
        }
    },

    async deleteClienScheduleById(_, id) {
        const response = await this.$api.clients.deleteScheduleById(id)
        return response.status === 204
    },

    async deleteClienScheduleAllByService(_, params) {
        const response = await this.$api.clients.deleteScheduleAllByServive(params)
        return response.status === 204
    },
    async deleteClienScheduleAll(_, params) {
        const response = await this.$api.clients.deleteScheduleAll(params)
        return response.status === 204
    },
    async editClientSchedule(_, {
        id,
        form,
    }) {
        const response = await this.$api.clients.editSchedule(id, form)
        return response.status === 204
    },
}

const getters = {
    clientRequests: (state) => state.clientRequests,
    clientsData: (state) => state.data,
    newClientsGetters: (state) => state.newClients,
    clientGetters: (state) => state.client,
    clientModalGetters: (state) => state.modal,
    clientReviewsGetters: (state) => state.clientReviews,
    clientDeletionStatusGetters: (state) => state.deletion_tag,
    clientModalType: (state) => state.type,
    clientSchedule: (state) => state.schedule,
    isOpenedClientScheduleModal: (state) => state.isOpenedClientScheduleModal,
    clientScheduleList: (state) => state.scheduleList,
    scheduleListByService: (state) => state.scheduleListByService,
    scheduleServiceId: (state) => state.scheduleServiceId,
    scheduleOfficeId: (state) => state.scheduleOfficeId,
    clientParams: (state) => state.params,
    historyCommunication: (state) => state.historyCommunication,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
